import { render, staticRenderFns } from "./EquipMaint.vue?vue&type=template&id=20dd5b0e"
import script from "./EquipMaint.vue?vue&type=script&lang=js"
export * from "./EquipMaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports